
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('captionButton.vrun.component', () => import('./CaptionButton.vue'))